export function cloneAttributes(
  target: Element,
  source: Element,
  exceptionList?: string[]
) {
  [...source.attributes]
    .filter(({nodeName}) =>
      exceptionList ? !exceptionList.includes(nodeName) : true
    )
    .forEach(({nodeName, nodeValue}) => {
      if (!nodeValue) {
        return;
      }
      if (nodeName === 'id') {
        target.setAttribute('data-id', nodeValue);
      } else {
        target.setAttribute(nodeName, nodeValue);
      }
    });
}
